import { render } from "./OnboardingInitialStep.vue?vue&type=template&id=737a5e1f&scoped=true&ts=true"
import script from "./OnboardingInitialStep.vue?vue&type=script&lang=ts"
export * from "./OnboardingInitialStep.vue?vue&type=script&lang=ts"

import "./OnboardingInitialStep.vue?vue&type=style&index=0&id=737a5e1f&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737a5e1f"]])

export default __exports__